import { SVGAttributes } from "react";
const SvgSearchEyeFill = (props: SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0111 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 01-1.969 5.617zm-5.853-9.44a4 4 0 102.646 2.646 2 2 0 11-2.646-2.647z" />
  </svg>
);
export default SvgSearchEyeFill;
